import { useCallback } from 'react';

interface IUseInfiniteScrollTriggerParams {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

/**
 * Returns a scroll handler that fetches the next page when the list is scrolled
 * to the bottom, guarding against fetching past the final page or while a fetch
 * is already in flight. The caller computes `atBottom` from whichever node it
 * owns (the window or a scroll container), so the same guard powers both the
 * window-scroll and element-scroll list variants.
 */
export function useInfiniteScrollTrigger({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: IUseInfiniteScrollTriggerParams) {
  return useCallback(
    (atBottom: boolean) => {
      if (atBottom && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage],
  );
}
